var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    className: "chip",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F3F3",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#D9D9D9",
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 3.5
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AEADAD",
    fillRule: "nonzero",
    points: "14 12 31 12 31 14 14 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AEADAD",
    fillRule: "nonzero",
    points: "14 32 31 32 31 34 14 34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardChip);
export default __webpack_public_path__ + "static/media/card-chip.0071e4d5.svg";
export { ForwardRef as ReactComponent };